module.exports = __webpack_public_path__ + "static/img/xibeimeng.fcd94ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/xibeimeng.png
// module id = KyGY
// module chunks = 1